import Error404Page from 'app/main/errors/Error404Page';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { cloneDeep } from 'lodash-es';
import { lazy, Suspense } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

const PerformanceDashboard = lazy(
  () => import('../../../../main/agency/profile/performance-sections/performance-dashboard/PerformanceDashboard')
);

const QaReportPage = lazy(
  () => import('../../../../main/agency/profile/performance-sections/qa-report-page/QaReportPage')
);

const CtpPage = lazy(() => import('../../../../main/agency/profile/performance-sections/ctp-page/CtpPage'));

const AgencyPerformanceSections = lazy(
  () => import('../../../../main/agency/profile/performance-sections/PerformanceSections')
);

export const agencyPerformanceRoutes: RouteObject[] = [
  {
    path: '',
    element: <AgencyPerformanceSections />,
    children: [
      {
        path: '',
        element: <Navigate replace to="dashboard" />,
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PerformanceDashboard />
          </Suspense>
        ),
      },
      {
        path: 'qa-report',
        element: (
          <Suspense fallback={<DataLoader />}>
            <QaReportPage />
          </Suspense>
        ),
      },
      {
        path: 'ctp-records',
        element: (
          <Suspense fallback={<DataLoader />}>
            <CtpPage view="agency" />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: <Error404Page />,
      },
      {
        path: ':any/*',
        element: <Error404Page />,
      },
    ],
  },
];

export const getAgencyPerformanceRoutes = (excludes: string[]): RouteObject[] => {
  const routes = cloneDeep(agencyPerformanceRoutes);
  const result =
    routes[0].children?.filter((route: RouteObject) => {
      const path = route.path || '';
      return !excludes.some((exclude) => path.includes(exclude));
    }) ?? [];

  routes[0].children = result;
  return routes;
};
